const columnCategory = state => state.columnCategory
const columnCategories = state => state.columnCategories
const columnCategoriesTree = state => state.columnCategoriesTree

export default {
  columnCategory,
  columnCategories,
  columnCategoriesTree
}
